import * as React from 'react';

import styles from './InfrastructureLayout.css';
import { IGetInfrastructureElementsResult } from '../../../utils/get_infrastructure_list';
import { isArrayWithItems } from '../../../utils/helpers';
import { BlockClip } from '../block_clip';
import { Card } from '../card';

const COUNT_INFRASTRUCTURES_ON_PREVIEW = 5;

export interface IInfrastructureLayoutStateProps {
  infrastructureList: IGetInfrastructureElementsResult[];
  isCroppedCard?: boolean;
}

type TInfrastructureLayoutProps = IInfrastructureLayoutStateProps;

export class InfrastructureLayout extends React.Component<TInfrastructureLayoutProps> {
  public render() {
    const { infrastructureList, isCroppedCard } = this.props;

    if (isCroppedCard || !isArrayWithItems(infrastructureList)) {
      return null;
    }

    return (
      <Card joinTop>
        <div className={styles['title']}>Инфраструктура</div>
        <BlockClip size={COUNT_INFRASTRUCTURES_ON_PREVIEW} text="Читать полностью" textClassName={styles['more']}>
          {infrastructureList.map(({ text, icon }) => (
            <div key={text} className={styles['infrastructure_item']}>
              <div className={styles['infrastructure_icon']}>{icon()}</div>
              <div className={styles['infrastructure_text']}>{text}</div>
            </div>
          ))}
        </BlockClip>
      </Card>
    );
  }
}
